import type { FC } from 'react'
import CartButton from '../shopping-cart/buttons/CartButton'
import PlaceholderKorag from '@g4g/ui/src/internal/PlaceholderKorag'

const EmptyCart: FC = () => (
  <div className="mt-6">
    <PlaceholderKorag callToAction={<CartButton href="/deals">Browse Deals</CartButton>}>
      Your shopping cart is empty
    </PlaceholderKorag>
  </div>
)

export default EmptyCart
